import React from 'react'

function FeatureThree() {
    return (
        <>
            {/* Feature area Start */}
            <section className="rts-feature-area rts-section-gap">
                <div className="container">
                    <div className="section-title-area2">
                        <p
                            className="sub-title cd wow fadeInUp"
                            data-wow-delay=".2s"
                            data-wow-duration="2s"
                        >
                            Features
                        </p>
                        <h2
                            className="section-title cd wow fadeInUp"
                            data-wow-delay=".5s"
                            data-wow-duration="2s"
                        >
                            Innovative Features <br /> for Meme Lovers
                        </h2>
                    </div>
                    <div className="section-inner mt--70">
                        <div className="feature-list left">
                            <div
                                className="single-list with-after wow fadeInLeft"
                                data-wow-delay=".8s"
                                data-wow-duration="2s"
                            >
                                <div className="inner">
                                    <h4 className="title">
                                        Community <br /> -Driven
                                    </h4>
                                    <img src="assets/images/features/coin-01.svg" alt="" />
                                </div>
                            </div>
                            <div
                                className="single-list with-after wow fadeInLeft"
                                data-wow-delay="1s"
                                data-wow-duration="2s "
                            >
                                <div className="inner">
                                    <h4 className="title">Deflationary Supply</h4>
                                    <img src="assets/images/features/coin-01.svg" alt="" />
                                </div>
                            </div>
                            <div
                                className="single-list with-after wow fadeInLeft"
                                data-wow-delay="1.2s"
                                data-wow-duration="2s"
                            >
                                <div className="inner">
                                    <h4 className="title">Security &amp; Transparency</h4>
                                    <img src="assets/images/features/coin-01.svg" alt="" />
                                </div>
                            </div>
                        </div>
                        <div
                            className="image-area wow scaleIn"
                            data-wow-delay=".8s"
                            data-wow-duration="1s"
                        >
                            <img src="assets/images/features/feature-01.webp" alt="" />
                        </div>
                        <div className="feature-list right">
                            <div
                                className="single-list with-after wow fadeInRight"
                                data-wow-delay=".8s"
                                data-wow-duration="2s"
                            >
                                <div className="inner">
                                    <img src="assets/images/features/coin-01.svg" alt="" />
                                    <h4 className="title">NFT Integration</h4>
                                </div>
                            </div>
                            <div
                                className="single-list with-after wow fadeInRight"
                                data-wow-delay="1s"
                                data-wow-duration="2s"
                            >
                                <div className="inner">
                                    <img src="assets/images/features/coin-01.svg" alt="" />
                                    <h4 className="title"> Creator Rewards</h4>
                                </div>
                            </div>
                            <div
                                className="single-list with-after wow fadeInRight"
                                data-wow-delay="1.2s"
                                data-wow-duration="2s"
                            >
                                <div className="inner">
                                    <img src="assets/images/features/coin-01.svg" alt="" />
                                    <h4 className="title">Low Transaction</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Feature area End */}
        </>

    )
}

export default FeatureThree